<template>
  <div>
    <market-overview v-if="enterpriseInfo && openMarket"></market-overview>
    <enterprise-overview v-if="enterpriseInfo && !openMarket"></enterprise-overview>
  </div>
</template>
<script>
import MarketOverview from './components/market';
import EnterpriseOverview from './components/enterprise';
export default {
  name: 'Over',
  components: {
    'market-overview': MarketOverview,
    'enterprise-overview': EnterpriseOverview
  },
  computed: {
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    openMarket() {
      return this.$store.state.enterprise.enterpriseInfo.openMarket;
    }
  },
  created() {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/overview/index.vue